import getColor from "@insite/mobius/utilities/getColor";
import { navigationDrawerStyles as styles } from "@tggstore/Overrides/Components/NavigationDrawer";
import { colorStrings } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

const commonTypograpyStyles = {
    size: 16,
    weight: 400,
    lineHeight: 1.4,
};

const commonButtonStylesMobile = css`
    width: 100%;
    padding: 8px 16px;
    height: 40px;
    background: transparent !important;
    text-align: left;
    display: inline-flex;

    &&&& span.main-navigation-row-text {
        text-transform: none;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 22.4px */
    }
`;

styles.mainNavigationRowTypography = {
    ...styles.mainNavigationRowTypography,
    ...commonTypograpyStyles,
    color: `${getColor(colorStrings.textMain)}`,
};

styles.drawer = {
    ...styles.drawer,
    cssOverrides: {
        drawerTitle: css`
            background: ${getColor(colorStrings.primaryMain)};
            color: ${getColor(colorStrings.commonGlobalWhite)};
        `,
        drawerBody: css`
            background: ${getColor(colorStrings.commonGlobalWhite)};
        `,
    },
    closeButtonProps: {
        css: css`
            background: transparent;
            border: none;
            color: ${getColor(colorStrings.commonGlobalWhite)};

            svg {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        `,
    },
};

styles.drawerSectionWrapper = {
    ...styles.drawerSectionWrapper,
    css: css`
        display: flex;
        flex-direction: column;
        color: ${getColor(colorStrings.textMain)};

        &:first-child {
            margin-top: 0;
            padding: 0;
            background: ${getColor(colorStrings.primaryMain)};
            color: ${getColor(colorStrings.commonGlobalWhite)};
        }

        &:last-child {
            margin-bottom: 5px;
        }
    `,
};

styles.mainNavigationRow = {
    ...styles.mainNavigationRow,
    ...commonTypograpyStyles,

    css: css`
        ${commonButtonStylesMobile}
        border-top: 1px solid transparent;
        margin-top: -1px;

        svg {
            color: ${getColor(colorStrings.commonGlobalWhite)};
        }
    `,
};

styles.panelMenu = {
    ...styles.panelMenu,
    cssOverrides: {
        wrapper: css`
            background: transparent !important;
            color: ${getColor(colorStrings.textMain)};

            a,
            > button,
            a {
                ${commonButtonStylesMobile}
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        `,
    },
    childTypographyProps: {
        mergeCss: true,
        color: colorStrings.textMain,
        ellipsis: true,
        size: 16,
        transform: "none",
        css: css`
            background: transparent;
            color: ${getColor(colorStrings.textMain)};
        `,
    },
    bodyColor: colorStrings.commonGlobalWhite,
    headerColor: colorStrings.primaryMain,
    panelRowProps: {
        css: css`
            border-top: 1px solid ${getColor(colorStrings.commonGlobalGray06)};

            svg {
                color: ${getColor(colorStrings.textMain)};
            }
        `,
    },

    mergeCss: true,
};

styles.logoLinks = {
    color: colorStrings.textMain,
    typographyProps: {
        size: 16,
        ellipsis: true,
    },
    css: css`
        &.logo-links-row.logo-links-row--warehouse {
            padding: 8px 0 0;
        }

        &.logo-links-row {
            ${commonButtonStylesMobile};
            color: ${getColor(colorStrings.textMain)};
            border-top: 1px solid ${getColor(colorStrings.commonGlobalGray06)};
            margin-top: -1px;

            svg {
                color: ${getColor(colorStrings.textMain)};
            }
        }
    `,
};

styles.userRowTypography = {
    color: colorStrings.commonGlobalWhite,
    transform: "none",
    size: 16,
};

styles.signOutRow = {
    css: css`
        background: transparent;
        border-top: 1px solid ${getColor(colorStrings.commonGlobalGray06)};
        border-bottom: 1px solid ${getColor(colorStrings.commonGlobalGray06)};
    `,
};

styles.signOutRowText = {
    ...styles.signOutRowText,
    color: colorStrings.textMain,
    size: 16,
    transform: "none",
    css: css`
        font-weight: 400;
        font-size: 16px;
    `,
};

styles.menuTriggerButton = {
    ...styles.menuTriggerButton,
    css: css`
        background: ${getColor(colorStrings.primaryMain)};
        border: none;
        color: ${getColor(colorStrings.commonGlobalWhite)};
    `,
};
